import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import BarChart from "./BarChart";
import { categories } from "../../pages/Evaluation/questions";
import {
  changeStep,
  fetchResult,
  fetchDrivers
} from "../../modules/results/actions";
import { changeLanguage } from "../../modules/preference/actions";

class BarChartContainer extends React.Component {
  render() {
    let drivers = {};
    let data;
    let results = {
      twelvesections: {},
      twentyfivesections: {}
    };
    //Formarting the driver data so it fits the barchart
    this.props.drivers.forEach(function(v) {
      v.results.forEach(function(b) {
        results[v.type][b.key] = b.own;
      });

      drivers = results;
    });

    if(!!Object.keys(drivers).length) {
      data = Object.keys(categories["twentyfivesections"]).map(x => {
        const id = categories["twentyfivesections"][x][this.props.language];
        return {
          key: id,
          "12 Sections Driver": drivers["twelvesections"][id],
          "24 Questions Driver": drivers["twentyfivesections"][id]
        }
    })}

    return <BarChart data={data} highlight={this.props.highlight} />;
  }
}

function mapStateToProps(state) {
  return {
    step: state.results.step,
    language: state.preference.language
  };
}

const mapActionsToProps = {
  changeStep,
  fetchResult,
  fetchDrivers,
  changeLanguage
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(BarChartContainer)
);



// WEBPACK FOOTER //
// ./src/components/Charts/BarChartContainer.js